import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Settings as SettingsIcon, Sparkles, ChevronRight, Wrench } from "lucide-react";
import { Link } from "react-router-dom";
import PwaInstallCard from "@/pwa/PwaInstallCard";

const SettingsPage = () => {
  return (
    <div data-testid="settings-page">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-[#0F1F3D] tracking-tight">
          Ustawienia
        </h1>
        <p className="text-gray-500 mt-1">
          Konfiguracja aplikacji PAX
        </p>
      </div>

      <div className="grid gap-6">
        {/* KSeF Configuration — jedyna aktywna sekcja */}
        <Link to="/ksef-config" data-testid="settings-link-ksef">
          <Card className="border border-gray-200 hover:border-[#2563EB] hover:shadow-sm transition-all cursor-pointer">
            <CardContent className="p-6 flex items-center gap-4">
              <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <SettingsIcon className="w-6 h-6 text-[#2563EB]" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-[#0F1F3D]">Konfiguracja KSeF</h3>
                <p className="text-sm text-gray-500 mt-0.5">
                  NIP firmy, certyfikat mTLS, diagnostyka połączenia z Krajowym Systemem e-Faktur
                </p>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 flex-shrink-0" />
            </CardContent>
          </Card>
        </Link>

        {/* Ustawienia agentów AI — aktywny panel */}
        <Link to="/ai-agents-settings" data-testid="settings-link-ai-agents">
          <Card className="border border-gray-200 hover:border-[#2563EB] hover:shadow-sm transition-all cursor-pointer">
            <CardHeader className="pb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-amber-50 rounded-lg flex items-center justify-center">
                  <Sparkles className="w-5 h-5 text-amber-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <CardTitle className="text-base text-[#0F1F3D]">Ustawienia agentów AI</CardTitle>
                  <CardDescription>
                    Dostosuj działanie agentów AI, wybierz model i skonfiguruj ich zachowanie.
                  </CardDescription>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400 flex-shrink-0" />
              </div>
            </CardHeader>
            <CardContent className="pt-0">
              <div className="flex justify-end">
                <Button
                  type="button"
                  data-testid="settings-ai-agents-open-btn"
                  className="bg-blue-600 hover:bg-blue-700 pointer-events-none"
                  tabIndex={-1}
                >
                  Otwórz konfigurację
                </Button>
              </div>
            </CardContent>
          </Card>
        </Link>

        {/* Narzędzia developerskie — reset danych testowych */}
        <Link to="/dev-tools" data-testid="settings-link-dev-tools">
          <Card className="border border-gray-200 hover:border-[#2563EB] hover:shadow-sm transition-all cursor-pointer">
            <CardContent className="p-6 flex items-center gap-4">
              <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Wrench className="w-6 h-6 text-gray-700" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-[#0F1F3D]">Narzędzia developerskie</h3>
                <p className="text-sm text-gray-500 mt-0.5">
                  Reset danych testowych oraz wyników działania agentów AI.
                </p>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 flex-shrink-0" />
            </CardContent>
          </Card>
        </Link>

        {/* Instalacja aplikacji PWA */}
        <PwaInstallCard />
      </div>
    </div>
  );
};

export default SettingsPage;
